export default __webpack_public_path__ + "static/media/publish.f8f93698.svg";